/**
 * Bridge so slash / paste / drop can kick off video uploads without threading
 * DocEditor refs through every call site.
 *
 * Also keeps the File around after a failed upload so Retry can re-send
 * without asking the user to pick the same video again.
 */

let starter = null;

/** @type {Map<string, File>} */
const pendingFiles = new Map();

/** @param {(blockId: string, file: File) => void} fn */
export const registerDocVideoUploadStarter = (fn) => {
  starter = fn;
};

export const rememberPendingDocVideoFile = (blockId, file) => {
  if (!blockId || !file) return;
  pendingFiles.set(blockId, file);
};

export const clearPendingDocVideoFile = (blockId) => {
  if (!blockId) return;
  pendingFiles.delete(blockId);
};

export const hasPendingDocVideoFile = (blockId) =>
  Boolean(blockId && pendingFiles.has(blockId));

export const startDocVideoUpload = (blockId, file) => {
  if (!blockId || !file) return;
  rememberPendingDocVideoFile(blockId, file);
  starter?.(blockId, file);
};

/** Re-run upload using the File kept from the last attempt. */
export const retryDocVideoUpload = (blockId) => {
  const file = blockId ? pendingFiles.get(blockId) : null;
  if (!file) return false;
  starter?.(blockId, file);
  return true;
};
